"use client";

import createIconSet from './createIconSet';
import font from './vendor/react-native-vector-icons/Fonts/Zocial.ttf';
import glyphMap from './vendor/react-native-vector-icons/glyphmaps/Zocial.json';

export default createIconSet(glyphMap, 'zocial', font);
